module.exports = __webpack_public_path__ + "static/media/defaultThumbnail.265cdb00.png";